module.exports = __webpack_public_path__ + "media/images/weather/266_day-70e1baeb9b4eac81f4e7494b7225c2aa.png";